import { Box, Button, makeStyles, Popover, useTheme } from '@material-ui/core';
import Circle from '@src/components/Common/Circle';
import { parseMessage } from '@src/locales/intl';
import { b2chatred } from '@src/muithemes/b2ChatTheme';
import { fetchNotificationTimeLimit } from '@src/reducers/chats';
import { ActionMode } from '@src/reducers/chats/initialState';
import { chatSearchActions } from '@src/reducers/chatSearch';
import { countActiveSideFiltersSelector } from '@src/selectors/chatSearch';
import { useEffect, useRef, useState } from 'react';
import 'react-day-picker/lib/style.css';
import { useDispatch, useSelector } from 'react-redux';
import AdvancedFiltersIcon from '../../../resources/icons/AdvancedFiltersIcon';
import AdvancedSearchForm from './AdvancedSearchForm/AdvancedSearchForm';
import AdvancedSearchResults from './AdvancedSearchResults';

const useStyles = makeStyles(theme => ({
  chatFilterIcon: {
    color: theme.palette.text.primary,
  },
}));

const AdvancedSearch = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { chatFilterIcon } = useStyles();

  const advancedSearchesBtn = useRef<HTMLButtonElement>(null);
  const [isOpenSearchAdvanced, setOpenSearchAdvanced] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const countActiveSideFilters = useSelector(countActiveSideFiltersSelector);

  // Remount form when popover opens so nested DatePickerInput gets fresh state (fixes freeze after close/reopen)
  useEffect(() => {
    if (isOpenSearchAdvanced) setFormKey(k => k + 1);
  }, [isOpenSearchAdvanced]);

  useEffect(() => {
    dispatch(chatSearchActions.fetchTags());
    dispatch(chatSearchActions.fetchDepartments());
    dispatch(chatSearchActions.fetchBotAccounts());
    dispatch(fetchNotificationTimeLimit({ mode: ActionMode.GET }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box px={1}>
      <Button
        className={chatFilterIcon}
        color="inherit"
        size="small"
        ref={advancedSearchesBtn}
        onClick={() => setOpenSearchAdvanced(!isOpenSearchAdvanced)}
      >
        <Box display="flex" gridGap={5} alignItems="center">
          <AdvancedFiltersIcon />
          {parseMessage('Console.Chats.Filters')}
          <Circle
            size={18}
            style={{
              color: '#FFF',
              fontWeight: 600,
              fontSize: '.88rem',
              backgroundColor: b2chatred[500],
            }}
          >
            {countActiveSideFilters}
          </Circle>
        </Box>
      </Button>
      <AdvancedSearchResults />

      <Popover
        open={isOpenSearchAdvanced}
        onClose={() => setOpenSearchAdvanced(false)}
        anchorEl={advancedSearchesBtn.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        marginThreshold={10}
        PaperProps={{
          style: {
            marginTop: 10,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <AdvancedSearchForm
          key={`advanced-search-form-${formKey}`}
          isFiltersPopoverOpen={isOpenSearchAdvanced}
        />
      </Popover>
    </Box>
  );
};

export default AdvancedSearch;
